export const SUBTEMPLATE_PATTERN = /{{\s*st\s+['"](\s*[\w\s-]*\s*)['"]\s*}}/g
export const DATAFIELD_PATTERN = /{{\s*df\s+['"](\s*\$.[\w.]*\s*)['"]\s*}}/g

export const preprocessContentForTiptap = (content: string) => {
  if (!content) return ''

  const withReplacedSt = content.replace(
    SUBTEMPLATE_PATTERN,
    (match, rawName) => {
      const trimmedName = rawName.trim()
      const safeName = trimmedName.replace(/"/g, '&quot;')
      const nodeType = 'st'

      return `<span data-${nodeType}-node data-${nodeType}-name="${safeName}">${match}</span>`
    }
  )

  const withReplacedDf = withReplacedSt.replace(
    DATAFIELD_PATTERN,
    (match, rawPath) => {
      const trimmedPath = rawPath.trim()
      const safeName = trimmedPath.replace(/"/g, '&quot;')
      const nodeType = 'df'

      return `<span data-${nodeType}-node data-${nodeType}-name="${safeName}">${match}</span>`
    }
  )

  return withReplacedDf.replace(/\n/g, '<br />')
}

export const postprocessContentForBackend = htmlFromTiptap => {
  if (!htmlFromTiptap) return ''

  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlFromTiptap, 'text/html')

  doc.querySelectorAll('span[data-df-node]').forEach(span => {
    const name = span.getAttribute('data-df-name')
    if (name) {
      span.replaceWith(`{{df '${name}'}}`)
    } else {
      span.remove()
    }
  })

  doc.querySelectorAll('span[data-st-node]').forEach(span => {
    const name = span.getAttribute('data-st-name')
    if (name) {
      span.replaceWith(`{{st '${name}'}}`)
    } else {
      span.remove()
    }
  })

  return doc.body.innerHTML
}
